module.exports = __webpack_public_path__ + "assets/AirbnbCerealMedium.220b1dd31cbf1b11825433158d644def.woff";